export interface ClueRow {
  id: string;
  origin: string;
  summary: string;
  keyPoint: string;
  status: '已交叉印证' | '待补充' | '需二次核对' | '已排除';
}

export interface VerifyCase {
  caseTitle: string;
  caseNo: string;
  tag: string;
  intro: string;
  rows: ClueRow[];
  conclusion: string;
  updatedAt: string;
}

export const VERIFY_CASE: VerifyCase = {
  caseTitle: '“到手价缩水”第一轮扫核工作台',
  caseNo: 'XL-26-0712',
  tag: '在核征集令',
  intro:
    '同一场大促活动，多名用户报称页面宣称的到手价与实际结算存在差价。以下线索已按指向一致性分类扫核，欢迎继续围观或补充。',
  updatedAt: '更新于今日 16:40',
  conclusion:
    '第一轮共采信 2 条交叉印证线索，指向“结算页展示价与账单价两套口径”，已转交平台方核验界面口径；另有 1 条线索因来源时间与活动不符予以排除。',
  rows: [
    {
      id: 'c-01',
      origin: '匿名网友·用户A',
      summary: '同一商品、同一场次下单两次，一次到手价界面正常，一次实付多出约 8%。',
      keyPoint: '两次实付金额与页面宣称差值稳定在 8%',
      status: '已交叉印证',
    },
    {
      id: 'c-02',
      origin: '热心网友·用户B',
      summary: '提供了客服聊天记录，客服答复“到手价以结算页面为准”。',
      keyPoint: '存在“界面到手价”与“结算到手价”两套口径',
      status: '待补充',
    },
    {
      id: 'c-03',
      origin: '匿名信源',
      summary: '给出对账单截图，账单内出现并列的两列价格，但未附下单录屏。',
      keyPoint: '账单存在两套价格列，需要录屏佐证',
      status: '需二次核对',
    },
    {
      id: 'c-04',
      origin: '围观网友·用户D',
      summary: '提供了一张历史活动截图，经核对属于上一档期活动，与本场无关。',
      keyPoint: '时间范围不符，未采纳',
      status: '已排除',
    },
  ],
};